export const DELETE_CONTACT = 'DELETE_CONTACT';
export const DELETE_DEALSPACE = 'DELETE_DEALSPACE';
export const DELETE_DEALSPACE_MEMBER = 'DELETE_DEALSPACE_MEMBER';
export const DELETE_DOCUMENT = 'DELETE_DOCUMENT';
export const DELETE_EMAIL = 'DELETE_EMAIL';
export const DELETE_FOLDER = 'DELETE_FOLDER';
export const DELETE_IMAGE = 'DELETE_IMAGE';
export const DELETE_LOCATION = 'DELETE_LOCATION';
export const DELETE_MEMBER = 'DELETE_MEMBER';
export const DELETE_PROPERTY = 'DELETE_PROPERTY';